import { Pressable, StyleSheet, View } from 'react-native';
import { Icon } from '../icon/Icon';
import { ICON_NAMES } from '../icon/icon.helper';
import { alert, neutrals, text } from 'src/theme/colors';
import { useStore } from 'src/contexts/StoreContext';
import { DYNAMIC_MODAL_VIEWS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import TextLato from '../text/text-lato/TextLato';
import { useRoute } from '@react-navigation/native';
import { ROUTE_NAMES } from 'src/routes/_shared/routes.constants';
import { qualityAlertBadgeTestID } from 'src/helpers/testIDs.helper';
import { IUserImageModel } from 'src/store/_models/userImage';

export const BadgeCropAlert = ({ text, userImage }: { text?: string; userImage?: IUserImageModel }) => {
  const {
    dynamicModal: { openModal },
  } = useStore();

  const route = useRoute();
  const isEditorNew = [ROUTE_NAMES.EditorNew].includes(route?.name as ROUTE_NAMES);

  return isEditorNew ? (
    <Pressable
      style={!!text ? style.badgeWithText : style.badge}
      onPress={() => {
        openModal({ dynamicModalView: DYNAMIC_MODAL_VIEWS.AdjustCrops });
      }}
      testID={qualityAlertBadgeTestID(userImage?.productId, userImage?.userImageAreaId)}
    >
      <View style={style.icon}>
        <Icon name={ICON_NAMES.Cut} color={neutrals.neutralGrays.tarmac} />
      </View>
      {!!text && <TextLato style={style.text}>{text}</TextLato>}
    </Pressable>
  ) : null;
};

const style = StyleSheet.create({
  badge: {
    width: 28,
    height: 28,
    borderWidth: 2,
    borderColor: neutrals.white,
    backgroundColor: alert.alertYellow,
    borderRadius: 28,
    shadowColor: neutrals.black,
    shadowOpacity: 0.3,
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowRadius: 3.8,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  badgeWithText: {
    flexDirection: 'row',
    height: 30,
    borderWidth: 2,
    borderColor: neutrals.white,
    backgroundColor: alert.alertYellow,
    borderRadius: 28,
    shadowColor: neutrals.black,
    shadowOpacity: 0.3,
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowRadius: 3.8,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    gap: 6,
    paddingHorizontal: 10,
  },
  text: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    color: text.secondaryText,
  },
  icon: {
    width: 18,
    height: 18,
    padding: 1,
  },
});
